import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../context/AuthContext';
import { useApiEnvironment } from '../../context/ApiEnvironmentContext';
import { useLocale } from '../../context/LocaleContext';
import { getContentUsageMetrics, getContentUsagePolicy } from '../../api/contentUsage';
import { contentUsageScope, contentUsageKeys, CONTENT_USAGE_READ_OPTIONS, CONTENT_USAGE_METRICS_OPTIONS } from '../../api/contentUsageQueries';
import DmProductView from './DmProductView';

export default function DmProductPage({ product }) {
  const { token, user, role, logout } = useAuth();
  const { apiEnvironment } = useApiEnvironment();
  const { locale } = useLocale();
  const location = useLocation();
  const navigate = useNavigate();
  const days = new URLSearchParams(location.search).get('range') === '30d' ? 30 : 7;
  const scope = contentUsageScope(apiEnvironment, token, user?.id, role);
  const metrics = useQuery({ queryKey: contentUsageKeys.metrics(scope, days), queryFn: () => getContentUsageMetrics(days, token), enabled: Boolean(token), ...CONTENT_USAGE_METRICS_OPTIONS });
  const policy = useQuery({ queryKey: contentUsageKeys.policy(scope), queryFn: () => getContentUsagePolicy(token), enabled: Boolean(token), ...CONTENT_USAGE_READ_OPTIONS });
  useEffect(() => { if ([metrics.error, policy.error].some(error => error?.status === 401)) logout(); }, [metrics.error, policy.error, logout]);
  return <DmProductView product={product} locale={locale} environment={apiEnvironment.toUpperCase()} days={days} metrics={metrics} policy={policy} onWindow={value => navigate(`${location.pathname}?range=${value}d`)} onRefresh={() => { metrics.refetch(); policy.refetch(); }} />;
}
